import { ComponentType, ReactNode, SVGProps } from 'react';

type PageHeaderProps = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: ReactNode;
  description?: ReactNode;
};

export const PageHeader = ({ icon: Icon, title, description }: PageHeaderProps) => (
  <header>
    <div className='flex items-center gap-3'>
      <Icon className='h-5 w-5 shrink-0 text-ob-icon' />
      <h1 className='text-2xl font-semibold text-ob-text'>{title}</h1>
    </div>
    {description && <p className='mt-2.5 max-w-[820px] leading-normal text-ob-text-subtle'>{description}</p>}
  </header>
);
